var routeTable = require('../table');
module.exports = routeTable(
	// universal
	{
		'': 'showSummary',		// default summary view
		'withdraw': 'withdraw',
		'zeroBalance': 'zeroBalance',
		'addFunds': 'addFunds',
		'repayFunds': 'repayBalance',
		'add/address(/*returnUrl)': 'addAddress',
		'confirmEmail': 'confirmEmail',
		'addGoal': 'addGoal',
		'liftWithdrawalLimits': 'liftWithdrawalLimits'
	},
	// clientOnly
	{
		'goal(/:goalId)(?showGoalDetailsAfterGoalReached=:showGoalDetailsAfterGoalReached)': 'goalDetails'
	},
	[
		'goal/:goalId?'
	]
);



//////////////////
// WEBPACK FOOTER
// ./routes/tables/summary-table.js
// module id = 867
// module chunks = 0